import { useMemo } from "react";
import { Message as AIMessage } from "ai";
import styles from "./AskAnythingChat.module.scss";
import { ChainOfThoughtStep } from "@/components/ai-elements/chain-of-thought-for-improve-chat";
import {
  Message,
  MessageContent,
  MessageResponse,
} from "@/components/ai-elements/message";
import { DotIcon, GripIcon } from "lucide-react";

interface AskAnythingChatMessageProps {
  message: AIMessage;
  isLast: boolean;
}

export function AskAnythingChatMessage({
  message,
  isLast,
}: AskAnythingChatMessageProps) {
  const isUser = message.role === "user";

  const customComponents = useMemo(() => {
    try {
      const components: JSX.Element[] = [];

      // Process tool invocations if any
      const toolInvocations = message.toolInvocations;
      if (toolInvocations && toolInvocations.length > 0) {
        // ... tool handling logic to be added
      }

      return components.length > 0 ? <>{components}</> : null;
    } catch (e) {
      console.error("Error parsing custom components:", e);
      return null;
    }
  }, [message.toolInvocations]);

  const hasText = message.content.trim().length > 0;
  const shouldRender = hasText || Boolean(customComponents);

  if (!shouldRender) {
    return null;
  }

  return (
    <ChainOfThoughtStep
      icon={isUser ? DotIcon : GripIcon}
      label={isUser ? "" : ""}
      status={isLast ? "active" : "complete"}
      variant="bubble"
      role={isUser ? "user" : "assistant"}
      className={styles.chainOfThoughtStep}
    >
      <Message from={isUser ? "user" : "assistant"}>
        <MessageContent className="group-[.is-user]:bg-foreground group-[.is-user]:text-background">
          {hasText && (
            <MessageResponse className={styles.messageText}>
              {message.content
                .replace(/^```markdown\s*/, "")
                .replace(/^```\s*/, "")
                .replace(/\s*```$/, "")}
            </MessageResponse>
          )}
          {customComponents && (
            <div className={styles.toolCards}>{customComponents}</div>
          )}
        </MessageContent>
      </Message>
    </ChainOfThoughtStep>
  );
}
